import { gql } from "@apollo/client";

const saveTag = gql`
  mutation SaveTag($tag: TagInput!) {
    saveTag(tag: $tag)
  }
`;

export default saveTag;
